import { render, staticRenderFns } from "./BsDropdownItem.vue?vue&type=template&id=98178e18&scoped=true&"
import script from "./BsDropdownItem.vue?vue&type=script&lang=js&"
export * from "./BsDropdownItem.vue?vue&type=script&lang=js&"
import style0 from "./BsDropdownItem.vue?vue&type=style&index=0&id=98178e18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98178e18",
  null
  
)

export default component.exports